import React from "react";
import { FaFilter, FaCalendarAlt, FaSortAmountDown, FaRedo, FaTimes } from 'react-icons/fa';

/**
 * Filtres Transactions - Interface responsive et professionnelle
 */
const TransactionFilters = ({
  selectedStatusFilter,
  selectedDateFilter,
  sortOrder,
  onStatusFilterChange,
  onDateFilterChange,
  onSortOrderChange,
  onResetFilters
}) => {
  const hasActiveFilters = selectedStatusFilter || selectedDateFilter || sortOrder;

  const sortOptions = [
    { value: '', label: 'Tri par défaut' },
    { value: 'asc_qty', label: 'Quantité croissante' },
    { value: 'desc_qty', label: 'Quantité décroissante' }
  ];

  return (
    <div className="mb-4 p-3 p-md-4 bg-white rounded-3 border shadow-sm">
      {/* Version Mobile: Layout vertical */}
      <div className="d-flex d-md-none flex-column gap-3 mb-3">
        <h6 className="fw-bold text-dark mb-0">Filtres</h6>
        
        {/* Filtre Statut Mobile */}
        <div className="input-group input-group-sm">
          <span className="input-group-text bg-light border-end-0">
            <FaFilter className="text-primary" size={12} />
          </span>
          <select 
            className="form-select border-start-0 bg-light"
            value={selectedStatusFilter}
            onChange={(e) => onStatusFilterChange(e.target.value)}
          >
            <option value="">Tous les statuts</option>
            <option value="Completed">Complété</option>
            <option value="Pending">En attente</option>
            <option value="Canceled">Annulé</option>
          </select>
        </div>

        {/* Filtre Date Mobile */}
        <div className="input-group input-group-sm">
          <span className="input-group-text bg-light border-end-0">
            <FaCalendarAlt className="text-primary" size={12} />
          </span>
          <select 
            className="form-select border-start-0 bg-light"
            value={selectedDateFilter}
            onChange={(e) => onDateFilterChange(e.target.value)}
          >
            <option value="">Toutes les dates</option>
            <option value="today">Aujourd'hui</option>
            <option value="this_week">Cette semaine</option>
            <option value="this_month">Ce mois-ci</option>
          </select>
        </div>

        {/* Tri Mobile */}
        <div className="input-group input-group-sm">
          <span className="input-group-text bg-light border-end-0">
            <FaSortAmountDown className="text-primary" size={12} />
          </span>
          <select 
            className="form-select border-start-0 bg-light"
            value={sortOrder}
            onChange={(e) => onSortOrderChange(e.target.value)}
          >
            {sortOptions.map(opt => (
              <option key={opt.value} value={opt.value}>{opt.label}</option>
            ))}
          </select>
        </div>

        {/* Badges Mobile */}
        {(selectedStatusFilter || selectedDateFilter) && (
          <div className="d-flex flex-wrap gap-2 mt-2">
            {selectedStatusFilter && (
              <span className="badge bg-primary bg-opacity-10 text-primary d-flex align-items-center gap-2 px-3 py-2 rounded-pill">
                <small>{selectedStatusFilter}</small>
                <FaTimes 
                  size={10} 
                  style={{ cursor: 'pointer' }} 
                  onClick={() => onStatusFilterChange('')} 
                />
              </span>
            )}
            {selectedDateFilter && (
              <span className="badge bg-info bg-opacity-10 text-info d-flex align-items-center gap-2 px-3 py-2 rounded-pill">
                <small>{selectedDateFilter.replace('_', ' ')}</small>
                <FaTimes 
                  size={10} 
                  style={{ cursor: 'pointer' }} 
                  onClick={() => onDateFilterChange('')} 
                />
              </span>
            )}
          </div>
        )}

        {/* Reset Mobile */}
        {hasActiveFilters && (
          <button 
            className="btn-reset-filters"
            onClick={onResetFilters}
          >
            <FaRedo size={12} />
            Réinitialiser les filtres
          </button>
        )}
      </div>

      {/* Version Tablette/Desktop: Layout horizontal */}
      <div className="d-none d-md-block">
        <div className="row g-3 align-items-end">
          {/* Filtre Statut */}
          <div className="col-md-6 col-lg-3">
            <label className="form-label small text-muted fw-semibold text-uppercase ls-1 mb-2">Statut</label>
            <div className="input-group">
              {/* <span className="input-group-text bg-light border-end-0">
                <FaFilter className="text-primary" size={14} />
              </span> */}
              <select 
                className="custom-select"
                value={selectedStatusFilter}
                onChange={(e) => onStatusFilterChange(e.target.value)}
              >
                <option value="">Tous les statuts</option>
                <option value="Completed">Complété</option>
                <option value="Pending">En attente</option>
                <option value="Canceled">Annulé</option>
              </select>
            </div>
          </div>

          {/* Filtre Date */}
          <div className="col-md-6 col-lg-3">
            <label className="form-label small text-muted fw-semibold text-uppercase ls-1 mb-2">Période</label>
            <div className="input-group">
              {/* <span className="input-group-text bg-light border-end-0">
                <FaCalendarAlt className="text-primary" size={14} />
              </span> */}
              <select 
                className="custom-select"
                value={selectedDateFilter}
                onChange={(e) => onDateFilterChange(e.target.value)}
              >
                <option value="">Toutes les dates</option>
                <option value="today">Aujourd'hui</option>
                <option value="this_week">Cette semaine</option>
                <option value="this_month">Ce mois-ci</option>
              </select>
            </div>
          </div>

          {/* Tri */}
          <div className="col-md-6 col-lg-3">
            <label className="form-label small text-muted fw-semibold text-uppercase ls-1 mb-2">Tri</label>
            <div className="input-group">
              {/* <span className="input-group-text bg-light border-end-0">
                <FaSortAmountDown className="text-primary" size={14} />
              </span> */}
              <select 
                className="custom-select"
                value={sortOrder}
                onChange={(e) => onSortOrderChange(e.target.value)}
              >
                {sortOptions.map(opt => (
                  <option key={opt.value} value={opt.value}>{opt.label}</option>
                ))}
              </select>
            </div>
          </div>

          {/* Badges & Reset */}
          <div className="col-md-6 col-lg-3">
            <div className="d-flex flex-column gap-2">
              {/* Badges */}
              <div className="d-flex flex-wrap gap-2" style={{ minHeight: '31px' }}>
                {selectedStatusFilter && (
                  <span className="badge bg-light border-dark bg-opacity-10 text-primary d-flex align-items-center gap-2 px-3 py-2 rounded-pill">
                    <small className="text-truncate" style={{ maxWidth: '100px' }}>{selectedStatusFilter}</small>
                    <FaTimes 
                      size={10} 
                      style={{ cursor: 'pointer', flexShrink: 0 }} 
                      onClick={() => onStatusFilterChange('')} 
                    />
                  </span>
                )}
                {selectedDateFilter && (
                  <span className="badge bg-light bg-opacity-10 text-info d-flex align-items-center gap-2 px-3 py-2 rounded-pill">
                    <small className="text-truncate" style={{ maxWidth: '100px' }}>{selectedDateFilter.replace('_', ' ')}</small>
                    <FaTimes 
                      size={10} 
                      style={{ cursor: 'pointer', flexShrink: 0 }} 
                      onClick={() => onDateFilterChange('')} 
                    />
                  </span>
                )}
              </div>

              {/* Bouton Reset */}
              {hasActiveFilters && (
                <button 
                  className="btn-reset-filters"
                  onClick={onResetFilters}
                >
                  <FaRedo size={12} />
                  <span>Réinitialiser</span>
                </button>
              )}
            </div>
          </div>
        </div>
      </div>

      <style>{`
        .order-filters-container {
          background: #f8f9fa;
          border-radius: 12px;
          padding: 1.25rem;
          margin-bottom: 1.5rem;
          border: 1px solid #e9ecef;
        }
          
        .custom-select:disabled {
          background: #f8f9fa !important;
          opacity: 0.6;
          cursor: not-allowed;
        }

        .filters-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 1rem;
        }

        .filters-title {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          font-weight: 600;
          color: #495057;
          font-size: 0.95rem;
        }

        .filter-icon {
          color: #6c757d;
          font-size: 0.875rem;
        }

        .results-badge {
          background: #dee2e6;
          color: #495057;
          padding: 0.2rem 0.6rem;
          border-radius: 20px;
          font-size: 0.75rem;
          font-weight: 600;
          margin-left: 0.5rem;
        }

        .btn-reset-filters {
          display: flex;
          align-items: center;
          gap: 0.4rem;
          padding: 0.4rem 0.875rem;
          border: 1px solid #dee2e6;
          background: white;
          border-radius: 20px;
          font-size: 0.8rem;
          color: #6c757d;
          cursor: pointer;
          transition: all 0.2s ease;
        }

        .btn-reset-filters:hover {
          background: #f8f9fa;
          border-color: #adb5bd;
          color: #495057;
        }

        .filters-row {
          display: flex;
          flex-wrap: wrap;
          gap: 1rem;
          align-items: flex-end;
        }

        .filter-group {
          display: flex;
          flex-direction: column;
          gap: 0.4rem;
          min-width: 220px;
          flex: 1;
          max-width: 300px;
        }

        .filter-label {
          font-size: 0.8rem;
          font-weight: 600;
          color: #6c757d;
          text-transform: uppercase;
          letter-spacing: 0.3px;
        }

        .custom-select-wrapper {
          position: relative;
          display: flex;
          align-items: center;
        }

        .custom-select {
          width: 100%;
          padding: 0.625rem 2.5rem 0.625rem 1rem;
          border: 1.5px solid #dee2e6;
          border-radius: 8px;
          background: white;
          font-size: 0.9rem;
          color: #495057;
          cursor: pointer;
          appearance: none;
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%236c757d' d='M6 8L1 3h10z'/%3E%3C/svg%3E");
          background-repeat: no-repeat;
          background-position: right 1rem center;
          transition: all 0.2s ease;
        }

        .custom-select:hover {
          border-color: #adb5bd;
        }

        .custom-select:focus {
          outline: none;
          border-color: #86b7fe;
          box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.1);
        }

        .status-indicator,
        .validation-indicator {
          position: absolute;
          right: 2.5rem;
          width: 8px;
          height: 8px;
          border-radius: 50%;
        }

        .validation-indicator {
          background: #0dcaf0;
        }

        .active-filters {
          display: flex;
          flex-wrap: wrap;
          gap: 0.5rem;
          align-items: center;
          padding-left: 0.5rem;
        }

        .filter-tag {
          display: inline-flex;
          align-items: center;
          gap: 0.4rem;
          padding: 0.35rem 0.75rem;
          border-radius: 20px;
          font-size: 0.8rem;
          font-weight: 500;
        }

        .filter-tag button {
          background: none;
          border: none;
          padding: 0;
          margin: 0;
          font-size: 1.1rem;
          line-height: 1;
          cursor: pointer;
          opacity: 0.6;
          transition: opacity 0.2s;
        }

        .filter-tag button:hover {
          opacity: 1;
        }

        @media (max-width: 768px) {
          .filters-row {
            flex-direction: column;
          }
          
          .filter-group {
            max-width: 100%;
            width: 100%;
          }
          
          .active-filters {
            padding-left: 0;
            width: 100%;
          }
        }
      `}</style>
      
    </div>
  );
};

export default TransactionFilters;